import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import axios from "axios";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import { addRoleAction, deleteRoleAction, getAllModules, getAllRoles, reassignRoleAction, setAddRoleResponse, setAllModules, setAllRoles, setDeleteRoleResponse, setReassignRoleResponse, updateRoleAction, updateRoleResponse } from "../reducers/roleSlice";


/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllRoleSaga(): any {
    yield put(setLoaderAction(true))
    console.log('plans-try')
    try {
       
        const res = yield call<any>(callAPI, {}, 'get', `client/roles`)
        console.log('plans-', res)
        if (res?.data) {
            yield put(setAllRoles(res?.data))
        }
    } catch (error:any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response, [401]);
        error?.code === "ERR_NETWORK" && handleError(error);
    }
    yield put(setLoaderAction(false))
}

function* getAllModulesSaga(): any {
    yield put(setLoaderAction(true))
    console.log('modules-try')
    try {
       
        const res = yield call<any>(callAPI, {}, 'get', `client/modules`)
        console.log('modules-', res)
        if (res?.data) {
            yield put(setAllModules(res?.data))
        }
    } catch (error:any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response, [401]);
        error?.code === "ERR_NETWORK" && handleError(error);
    }
    yield put(setLoaderAction(false))
}

function* addRoleSaga(payload: any[]):any {
    yield put(setLoaderAction(true))
    yield put(setNotificationAction({message: [], severity: 'error'}))
    try {
        console.log("payload",payload);
        const apiResponse = yield call<any>(callAPI, payload, 'post', 'client/roles')
        console.log('changePassword-', apiResponse)
        if (apiResponse?.success === true) {
            apiResponse && handleSuccess(apiResponse);
            yield put(setAddRoleResponse(true));
            yield put(setNotificationAction({message: [], severity: 'error'}))
        }
    } catch (error: any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(setAddRoleResponse(false));

    }
    yield put(setLoaderAction(false))
}

function* updateRoleSaga(payload: { payload: any }):any {
    yield put(setLoaderAction(true))
    yield put(setNotificationAction({message: [], severity: 'error'}))
    try {
        // const {id} = payload;
        console.log("payload", payload);
        const {id, ...newPayload} = payload?.payload;
        const apiResponse = yield call<any>(callAPI, {payload:newPayload}, 'put', `client/roles/${id}`)
        console.log('changePassword-', apiResponse)
        if (apiResponse?.success === true) {
            apiResponse && handleSuccess(apiResponse);
            yield put(updateRoleResponse(true));
            yield put(setNotificationAction({message: [], severity: 'error'}))
        }
    } catch (error: any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(updateRoleResponse(false));

    }
    yield put(setLoaderAction(false))
}

function* deleteRoleSaga(payload: { payload: any }): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: 'error' }));
    try {
        const roleId = payload?.payload?.role_id || payload?.payload?.id;
        const apiResponse = yield call<any>(callAPI, {}, 'delete', `client/roles/${roleId}`);
        if (apiResponse?.success === true) {
            apiResponse && handleSuccess(apiResponse);
            yield put(setDeleteRoleResponse(true));
            yield put(setNotificationAction({ message: [], severity: 'error' }));
        }
    } catch (error: any) {
        console.log('Catch Error-', error);
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(setDeleteRoleResponse(false));
    }
    yield put(setLoaderAction(false));
}


function* reassignRoleSaga(payload: { payload: any }): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: 'error' }));
    try {
        const { oldRoleId, ...newPayload } = payload?.payload;
        const apiResponse = yield call<any>(callAPI, { payload: newPayload }, 'delete', `client/roles/${oldRoleId}`);
        if (apiResponse?.success === true) {
            apiResponse && handleSuccess(apiResponse);
            yield put(setReassignRoleResponse(true));
            yield put(setNotificationAction({ message: [], severity: 'error' }));
        }
    } catch (error: any) {
        console.log('Catch Error-', error);
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(setReassignRoleResponse(false));
    }
    yield put(setLoaderAction(false));
}

export function* watchRole() {
    yield takeLatest<any>(getAllRoles, getAllRoleSaga);
    yield takeLatest<any>(addRoleAction, addRoleSaga);
    yield takeLatest<any>(getAllModules, getAllModulesSaga);
    yield takeLatest<any>(updateRoleAction, updateRoleSaga);
    yield takeLatest<any>(deleteRoleAction, deleteRoleSaga);
    yield takeLatest<any>(reassignRoleAction, reassignRoleSaga);
}